const IAPI = require('core/src/api-client-abstract').default;
const View = require('core/src/functions/view');
const Log = require('core/src/log');
const _ = require('core/src/utils/legacy');
const Function = require('core/src/function');
const Language = require('core/src/language').default;

var GridView = Function.extend(View, "GridView");

GridView.prototype._batchTriggers = undefined;

/**
 * @override
 * @returns {undefined}
 */
GridView.prototype.onInit = function(dependencies) {
	this.api = dependencies.get(IAPI);
	this.language = dependencies.get(Language);

	this.setModelUpdateHandler('data', handleDataUpdate);

	this.setParameters({
		'#data': undefined,
		'$column' : undefined, // backward compatibility
		'$columns': undefined,
		'$row': undefined,
		'$options' : undefined,
		'$hiddenColumns' : undefined,
		'$state': undefined,
		'$autoColumns': false,
		'$container.height': 200
	});
	this.setModelValidation({
		// Validation calls the function with this as a Validation instance, so we need to prevent that
		'data': [_.bind(this._validateData, this), {default: [], warn: _.def}],
		'column': ['isObject', {default: undefined, warn: _.def}],
		'row': ['isObject', {default: undefined, warn: _.def}],
		'options': ['isObject', {default: undefined, warn: _.def}],
		'hiddenColumns': ['isArray', {default: [], warn: _.def}],
		'state': [{
			selected: [['isObject'], {array: {itemType: 'row'}}],
			visible: [['isObject'], {array: {itemType: 'row'}}]
		}, this.language.translate("Invalid state."), {default: undefined, warn: _.def}]
	});

	this.setTemplating('column', false);
	this.setTemplating('columns', false);
};

GridView.prototype.createEmptyModel = function() {
	var model = View.prototype.createEmptyModel.call(this);
	model.state = {
		selected: [],
		visible: []
	};

	return model;
};

/**
 *
 * @param input
 */
GridView.prototype.setModelFromInput = function(input) {
	// Column settings
	var legacyColumns = _.get(input, 'column');
	if(_.def(legacyColumns)) {
		Log.warn("GridView parameter 'column' is deprecated. Please use 'columns' instead.");
		if(!_.def(_.get(input, 'columns'))) {
			input.columns = legacyColumns;
		}
	}
	// If data consists of columns, transpose data
	var data = _.get(input, 'data');
	if(_.isPlainObject(data)) {
		var newData = [];
		for(var col in data) {
			for(var row in data[col]) {
				if(!(row in newData)) {
					newData[row] = {};
				}
				newData[row][col] = data[col][row];
			}
		}
		input.data = newData;
	}
	// Create default state if not defined
	if(!_.def(input.state)) {
		input.state = {
			selected: [],
			visible: _.clone(input.data)
		};
	}

	return View.prototype.setModelFromInput.call(this, input);
};

let handleDataUpdate = function(newValue, oldValue) {
	var equals = this.getEqualsInCollectionFunction('data');
	var diff = _.collectionDiff(oldValue, newValue, equals);
	this.updateCollections({
		set: {
			state: {
				visible: diff.add
			}
		},
		remove: {
			state: {
				visible: diff.remove,
				selected: diff.remove
			}
		}
	});
};

/**
 * @override
 * @param data
 */
GridView.prototype.alterUpdateData = function(data) {
	data = data || {};
	if(_.isString(_.get(data, 'update.identifiers'))) {
		_.set(data, 'update.identifiers', _.parseArray(data.update.identifiers));
	}
	if(_.isString(_.get(data, 'remove.identifiers'))) {
		_.set(data, 'remove.identifiers', _.parseArray(data.remove.identifiers));
	}
	if(_.isString(_.get(data, 'remove.invert'))) {
		_.set(data, 'remove.invert', _.parseBoolean(data.remove.invert));
	}
	return data;
};

/**
 * @override
 * @param {object} input
 * @returns {object}
 */
GridView.prototype.alterRenderData = function(input) {
	input.batchTriggers = this.findBatchTriggers();
	return input;
};

GridView.prototype._validateData = function(data) {
	var validity = new _.Validity("data", data, true, this.language.translate('Table data must be either an array or an object of arrays.'));
	if(!_.isObject(data)) {
		validity.setValid(false);
		return validity;
	}

	if(_.isPlainObject(data)) {
		for(var key in data) {
			if(!_.isArray(data[key])) {
				validity.setValid(false);
				return validity;
			}
		}
		return validity;
	} else {
		return validity;
	}
};

module.exports = GridView;

